<section class="py-16">
  <div>
    <!-- Badge -->
    <div class="flex justify-center" data-aos="fade-up">
      <span
        data-aos="fade-up"
        class="inline-flex items-center justify-center gap-2 bg-white px-2.5 py-1.5 rounded-full border"
      >
        <span class="text-black font-medium text-base">
          {{ "recruiterProgram.targetAudience.badge" | translate }}
        </span>
        <app-icon name="svg:logo-white" [size]="24"/>
      </span>
    </div>

    <!-- Title -->
    <h2
      class="text-center text-[32px] md:text-[44px] lg:text-[52px] font-black leading-tight tracking-[-2px] text-[#000D4A] mt-6 mb-[80px]"
      data-aos="fade-up"
      data-aos-delay="50"
    >
      {{ "recruiterProgram.targetAudience.title" | translate }}
    </h2>

    <!-- Cards -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      <div
        *ngFor="let item of audiences; let i = index"
        class="bg-white rounded-2xl p-6 border border-gray-100 flex flex-col items-center text-center gap-5"
        data-aos="fade-up"
        [attr.data-aos-delay]="i * 100"
      >
        <div
          class="icon-container w-12 h-12 rounded-xl bg-[#EDF6FF] flex items-center justify-center shrink-0 border"
        >
          <app-icon [name]="item.icon" [size]="24" class="text-[#0367FB]"/>
        </div>
        <p class="font-medium text-base text-[#061430] leading-relaxed">
          {{ item.textKey | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
